import React, { Component } from 'react';
import '../../node_modules/font-awesome/css/font-awesome.min.css';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import itemImg from '../assets/images/future-collection-details/item-image.png';

class ClosedCollectionDetails extends Component {
    render() {
        return (
            <div className="main-wrapper">
                {/* Header area start */}
                <Header />
                {/* Header area end */}

                {/* Item details area start */}
                <div className="container mb-5">
                    <div className="row collection justify-content-between">
                        <div className="col-md-6 upcoming-collection">
                            <img src={itemImg} alt="" width="100%" />
                            <p><Link to="#">VIEW COLLECTION</Link>
                                <small className="pull-right">Contract Address</small>
                            </p>
                            <small className="pull-right">0xbfb69918f12eed843c67058b2ee9059f1440133e</small>
                        </div>

                        <div className="col-md-5 future-details mt-auto mb-4 ml-auto upcoming">
                            <h3>Okuda San Miguel<span>Opens in 5h 12m 27S</span></h3>
                            <h1>Kaleidoscopic Skulls
                                <span>
                                    Minimum Bid: $10,000.00
                                </span>
                            </h1>
                            <hr />
                            <p>Digital Trip
                                <span>Edition of 5</span>
                            </p>
                            <p>Kaleidoscopic Skulls exhibits an introspective journey of reflection about life and death.<br /><br />
                                Collectors will receive a signed, numbered, hyper limited art print (edition of 5)<br /><br />
                                Minimum Bid Increase: $10<br /><br />
                                Bids made in the last 3 minutes reset the timer to 3 minutes.
                            </p>
                            <button disabled>Dropping Soon</button>
                            <h6><Link to="#">View listings in marketplace</Link></h6>
                        </div>
                    </div>
                </div>
                {/* Item details area end */}
            </div>
        )
    }
};

export default ClosedCollectionDetails;